import gql from "graphql-tag";

export const GET_ENTITY_NAME = gql`
	query GetEntityName($entityId: ID) {
		flexEntityTypes(where: { id: $entityId }) {
			name
			localizationKey
			containerType
		}
	}
`;

export const START_PRELIMINARY_UPLOAD = gql`
	mutation StartPreliminaryUpload($input: UploadFlexEntityInput!) {
		StartPreliminaryUpload(input: $input)
	}
`;

export const START_FINAL_UPLOAD = gql`
	mutation StartFinalUpload($input: UploadFlexEntityInput!) {
		StartFinalUpload(input: $input)
	}
`;

export const GET_UPLOAD_REPORT = gql`
	query GetUploadReport {
		GetUploadReport {
			submittedEntities {
				patientId
				rowNumber
			}
			revokedEntities {
				patientId
				rowNumber
			}
			failedToRevoke {
				patientId
				rowNumber
			}
			updatedEntities {
				patientId
				attributesUpdated
				isSubmitted
				rowNumber
			}
			draftedEntities {
				patientId
				invalidAttributes {
					name
					status
					valueIsPresent
				}
				rowNumber
			}
			failedToCreate {
				patientId
				quantity
				invalidAttributes {
					name
					status
					valueIsPresent
				}
				hasNoValidScope
				hasNoValidDate
				hasImpossibleHighQuantity
				rowNumber
			}
			fileName
			lastUpdatedOn
			isComplete
			failedToAdd
			failedToUpdate {
				patientId
				rowNumber
			}
			casesCreated
			patientsCreated
			createdOn
			completedIn
			responseType
			ignoredRecords
			percentageSourceFile
			isCaselessRecord
		}
	}
`;

export const GET_UPLOAD_STATE = gql`
	query GetUploadState {
		GetUploadState {
			tenantId
			isFinal
			status
			flexEntityTypeId
			mappedFields {
				userField
				flexEntityField
				derivedFrom
			}
			sourceKeys
			percentage
			expectedRunAgreements {
				id
				name
			}
			completedAgreementIds
			uploadedById
			casesCreated
			patientsCreated
		}
	}
`;

export const CANCEL_UPLOAD = gql`
	mutation CancelUpload {
		CancelUpload
	}
`;

export const GET_EXISTING_FLEX_ENTITY_DATA = gql`
	query GetExistingFlexEntityData($entityId: ID!) {
		flexEntities(where: { type: { id: $entityId }, isUploaded: true, isDeleted: false }) {
			type {
				id
			}
			patientId
			patientIdKeys
		}
	}
`;
